<template>
  <div class="home" v-loading="loading">
    <div class="header">
      <!--
            <div class="add" @click="addlist(0)">
                <img class="ioc" src="../../assets/common/common-add.png" />
                <div class="addtext">添加</div>
            </div>
            -->
    </div>

    <div class="header-table">
      <el-table
        :data="tableData"
        border
        style="width: 100%; cursor: pointer"
        :header-cell-style="{ color: '#333333', backgroundColor: '#FAFAFA' }"
      >
        <!-- 自定义暂无数据 -->
        <template slot="empty">
          <div class="empty-block">
            <img
              class="empty-block-img"
              src="../../assets/common/common-empty.png"
            />
            <div class="empty-block-text">暂无数据～</div>
          </div>
        </template>
        <el-table-column prop="version_number" label="版本号" width="200">
        </el-table-column>
        <el-table-column prop="file" label="APP包"> </el-table-column>
        <el-table-column prop="" label="是否强制" width="200">
          <template slot-scope="scope">
            {{ scope.row.force == 0 ? '不强制' : '强制' }}
          </template>
        </el-table-column>
        <el-table-column prop="file" label="渠道" width="200">
          <template slot-scope="scope">
            {{
              scope.row.type == 0 ? 'Android' : scope.row.type == 1 ? 'iOS' : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="198">
          <template slot-scope="scope">
            <div style="display: flex">
              <div class="table-operation" @click="addlist(1, scope.row)">
                编辑
              </div>
              <div
                class="table-operation"
                style="margin-left: 20px"
                @click="examineBtn(scope.row)"
              >
                删除
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="header-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>

    <!--第一区域添加 弹出框-->
    <div class="addBlock">
      <el-dialog
        :visible.sync="addDialogVisible"
        width="444px"
        style="margin-top: 10vh"
        @close="addClose"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addBlock-div">
            <div class="addBlock-div-top">
              <div class="addBlock-div-top-title">
                {{ examineObj.type == 0 ? 'Android' : 'iOS' }}
                {{ addIndex == 0 ? '添加' : '编辑' }}
              </div>
              <img
                class="addBlock-div-top-close"
                src="../../assets/common/close.png"
                @click="addClose"
              />
            </div>

            <div class="addBlock-div-center">
              <div class="center-header">
                <div class="center-header-title">版本号</div>
                <div class="center-header-input">
                  <el-input
                    placeholder="请输入版本号"
                    v-model="additionTitle"
                    clearable
                  ></el-input>
                </div>
              </div>

              <div class="center-conversion">
                <div class="center-conversion-title">APP包</div>
                <div class="center-conversion-input">
                  <el-input
                    v-if="examineObj.type == 0"
                    placeholder="请输入APP包"
                    v-model="additionTextarea"
                    clearable
                    disabled
                  ></el-input>

                  <el-input
                    v-else
                    placeholder="请输入APP包地址"
                    v-model="additionTextarea"
                    clearable
                  ></el-input>
                </div>
              </div>

              <div class="center-conversion" >
                <div class="center-conversion-title">升级文案</div>
                <div class="center-conversion-input">
                  <el-input
                    placeholder="请输入升级文案"
                    v-model="additionTextareas"
                    clearable
                    type="textarea"
                    :rows="2"
                  ></el-input>
                </div>
              </div>

              <div class="center-display">
                <div class="center-conversion" style="width: 100%">
                  <div class="center-conversion-title">是否强制</div>
                  <div class="center-conversion-input">
                    <el-select
                      v-model="whetherType"
                      clearable
                      placeholder="请选择"
                      @change="stairChange"
                    >
                      <el-option
                        v-for="item in whetherList"
                        :key="item.label"
                        :label="item.value"
                        :value="item.label"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div
                  class="center-conversion"
                  style="width: 100%; margin-left: 20px"
                  v-if="examineObj.type == 0"
                >
                  <div class="center-conversion-title">上传APP包</div>
                  <div class="center-conversion-button">
                    <el-upload
                      class="upload-demo"
                      action="https://laravel-api-manager.xmw1688.com/common/upload"
                      :on-success="handleSuccess"
                      :show-file-list="false"
                      :on-progress="uploadVideoProcess"
                      ref="upload"
                    >
                      <el-button>
                        <div class="block">
                          <div class="title">
                            {{
                              loadProgress == 0
                                ? '点击上传'
                                : loadProgress >= 0 && loadProgress < 100
                                ? '上传中'
                                : loadProgress == 100
                                ? '上传完成'
                                : '上传失败'
                            }}
                          </div>
                          <el-progress
                            v-if="progressFlag"
                            :percentage="loadProgress"
                          ></el-progress>
                        </div>
                      </el-button>
                    </el-upload>
                  </div>
                </div>
              </div>
            </div>

            <div class="addBlock-div-button">
              <!-- <div class="addBlock-div-button-left" @click="addClose">
                  重 置
                </div> -->
              <div class="addBlock-div-button-right" @click="addConfirm">
                确 定
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getAndroid,
  getAndroidAdd,
  getAndroidDetail,
  deletefnAndroidDetail,
} from '../../api/common'

export default {
  comments() {},
  data() {
    return {
      // 添加 弹出框  是否开启
      addDialogVisible: false,
      addIndex: 0,
      // 添加 弹出框 标题
      additionTitle: '',
      // 添加 弹出框 富文本
      additionTextarea: '',
      additionTextareas: '',
      whetherType: 0,
      whetherList: [
        {
          label: 0,
          value: '不强制',
        },
        {
          label: 1,
          value: '强制',
        },
      ],
      //  添加 弹出框 错误
      additionError: false,
      /* 查看弹出框 */
      examineDialogVisible: true,
      // 查看弹出框 对象
      examineObj: {},

      /* end */
      tableData: [],
      totalNum: 0,
      // 页码
      page: 1,
      // 页数
      limit: 20,
      // 刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      basicFunShow: false,
      loadProgress: 0, // 动态显示进度条
      progressFlag: false, // 关闭进度条
    }
  },
  created() {
    this.loading = true
    this.getinformClick()

    setTimeout(() => {
      this.basicFunShow = this.$store.state.pageFunctionShow
    }, 1000)
  },
  methods: {
    // 获取通知列表接口
    getinformClick() {
      let params = {
        pageSize: this.limit,
        pageNo: this.page,
      }

      getAndroid(params).then((res) => {
        if (res.resultStatus == true) {
          console.log('获取接口返回', res)
          // 获取表格数据
          this.tableData = res.resultData
          // 获取表格总条数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },

    stairChange(e) {
      this.whetherType = e
    },
    // 查看弹出框 关闭
    examineClose() {
      this.examineDialogVisible = false
    },

    // 添加弹出框 开启
    addlist(index, item) {
      if (this.basicFunShow == false) {
        return
      }

      this.loadProgress = 0

      if (index == 0) {
        this.addIndex = 0
        this.additionTitle = ''
        this.additionTextarea = ''
        this.additionTextareas = ''
        this.addDialogVisible = true
      } else {
        this.addIndex = 1

        let params = item.id

        getAndroidDetail(params).then((res) => {
          if (res.resultStatus == true) {
            this.examineObj = res.resultData
            this.additionTitle = res.resultData.version_number
            this.additionTextareas = res.resultData.text
            this.whetherType = Number(res.resultData.force)
            this.additionTextarea = res.resultData.file
            this.addDialogVisible = true
          }
        })
      }
    },
    // 添加弹出框 确认
    addConfirm() {
      let params = {}

      if (this.addIndex == 0) {
        params = {
          id: '',
          version_number: this.additionTitle,
          file: this.additionTextarea,
          force: this.whetherType,
          text: this.additionTextareas
        }
      } else {
        params = {
          id: this.examineObj.id,
          version_number: this.additionTitle,
          file: this.additionTextarea,
          force: this.whetherType,
          text: this.additionTextareas
        }
      }

      getAndroidAdd(params).then((res) => {
        if (res.resultStatus == true) {
          this.loading = true
          this.addDialogVisible = false
          this.getinformClick()
        }
      })
    },
    // 删除
    examineBtn(item) {
      if (this.basicFunShow == false) {
        return
      }

      let params = item.id

      deletefnAndroidDetail(params).then((res) => {
        if (res.resultStatus == true) {
          this.loading = true
          this.addDialogVisible = false

          this.$message({
            message: '删除成功！',
            type: 'error',
          })

          this.getinformClick()
        }
      })
    },
    // 添加弹出框 重置
    addClose() {
      this.addDialogVisible = false
    },
    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      this.getinformClick()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      this.getinformClick()
    },
    // 上传成功
    handleSuccess(file, fileList) {
      this.$refs.upload.clearFiles()
      this.additionTextarea = file.resultData

      if (this.loadProgress == 99) {
        this.loadProgress = 100
        setTimeout(() => {
          this.progressFlag = false
        }, 1000) // 一秒后关闭进度条
      }
    },
    uploadVideoProcess(event, file, fileList) {
      this.progressFlag = true // 显示进度条
      this.loadProgress = parseInt(event.percent) // 动态获取文件上传进度
      if (this.loadProgress >= 100) {
        this.loadProgress = 99
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.home {
  margin: 0 auto;
  background-color: #f4f5f9;
  min-height: 900px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #edeff7;
  border-radius: 10px;
}

.header {
  height: 24px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;

  .add {
    width: 82px;
    height: 36px;
    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .ioc {
      width: 13px;
      height: 13px;
    }

    .addtext {
      margin-left: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.header-table {
  padding: 0 24px;
  box-sizing: border-box;

  /deep/ .el-table thead {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    background: #d8d8d8;
  }

  /deep/ .el-table tr {
    height: 46px;
  }

  /deep/ .el-table__empty-text {
    line-height: 0;
  }

  .empty-block {
    margin-top: 62px;
    padding-bottom: 40px;

    .empty-block-img {
      width: 130px;
      height: 130px;
      margin: 0 auto;
    }

    .empty-block-text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-top: 10px;
      height: 17px;
      line-height: 17px;
    }
  }

  .table-operation {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2aa4ff;
    text-decoration: underline;
  }
}

.header-Pagination {
  height: 88px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  /deep/ .el-pagination .btn-prev {
    padding: 0;
    width: 32px;
    height: 32px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
    margin-right: 8px;
  }

  /deep/ .el-pagination .btn-next {
    padding: 0;
    width: 32px;
    height: 32px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
  }

  /deep/ .el-pager li {
    padding: 0;
    width: 32px;
    height: 32px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
    line-height: 32px;
    margin-right: 8px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
  }

  /deep/ .el-pager li.active {
    background: #000000;
    color: #ffffff;
  }

  /deep/ .el-input--mini .el-input__inner {
    height: 32px;
  }

  /deep/ .el-input__inner {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
  }
}

// 添加
.addBlock {
  /deep/ .el-dialog {
    height: var(--height) !important;
    border-radius: 10px !important;
  }

  /deep/ .el-dialog__footer {
    padding: 0;
    text-align: left;
  }

  .addBlock-div {
    .addBlock-div-top {
      display: flex;
      height: 56px;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      box-sizing: border-box;
      border-bottom: 1px solid #e9edf4;

      .addBlock-div-top-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
      }

      .addBlock-div-top-close {
        width: 10px;
        height: 10px;
        cursor: pointer;
      }
    }

    .addBlock-div-center {
      padding: 20px 24px 21px;
      box-sizing: border-box;

      .center-header {
        .center-header-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .center-header-input {
          height: 32px;
          background: #ffffff;
          border-radius: 5px;
          margin-top: 4px;

          /deep/ .el-input {
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }
        }
      }

      .center-conversion {
        margin-top: 14px;

        .center-conversion-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .center-conversion-input {
          background: #ffffff;
          border-radius: 5px;
          margin-top: 4px;

          /deep/ .el-textarea {
            height: 152px;
            cursor: pointer;
          }

          /deep/ .el-textarea__inner {
            height: 152px;
            padding: 10px 10px 20px;
          }

          /deep/ .el-textarea .el-textarea__inner {
            // 然后找到对应的类名，在这里将拉伸去掉即可
            resize: none;
          }
        }

        .center-conversion-button {
          width: 95%;
          height: 39px;
          margin-top: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          color: #999;
          cursor: pointer;
          border-radius: 5px;

          /deep/ .el-progress__text {
            font-size: 14px !important;
            color: red;
            margin-top: -2px;
          }

          /deep/ .el-upload {
            width: 100%;
          }

          /deep/ .el-button:focus,
          .el-button:hover {
            background-color: #fff;
          }

          /deep/ .el-button {
            width: 100%;
            display: flex;
            justify-content: center;
          }

          .upload-demo {
            width: 100%;
            height: 100%;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .block {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
          }
        }
      }

      .center-display {
        display: flex;
        align-items: baseline;
        justify-content: space-between;

        /deep/ .el-select {
          width: 100%;
        }
      }
    }

    .addBlock-div-button {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 24px;
      box-sizing: border-box;
      height: 52px;
      border-top: 1px solid #e9edf4;

      .addBlock-div-button-left,
      .addBlock-div-button-right {
        width: 65px;
        height: 32px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #e9edf4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .addBlock-div-button-right {
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        margin-left: 8px;
        color: #ffffff;
      }
    }
  }
}
</style>
